module.exports = __webpack_public_path__ + "img/b978fa6.png";